// extracted by mini-css-extract-plugin
module.exports =  {"root":"a867bdd7c0--root--YOPzN","logo":"a867bdd7c0--logo--MbmYM","count":"a867bdd7c0--count--jj1Vg","rest":"a867bdd7c0--rest--zKtIJ"};